import { render, staticRenderFns } from "./FancyCard.vue?vue&type=template&id=0104d7ea"
import script from "./FancyCard.vue?vue&type=script&lang=js"
export * from "./FancyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports